import { entityTypes } from '../../static/types/objectType';
import { initialReducedManagerTypeWithQualityState } from '../../static/types/objectInitialState';
import { ReducedManagerTypeWithQuality } from '../../static/types/commonTypes/managerType';
import { initialReducedIndividualState } from '../../static/initialState/commonInitialState/initialReducedIndividualState';
import { initialReducedLegalEntityState } from '../../static/initialState/commonInitialState/initialReducedLegalEntityState';
import ReducedIndividualPerson from './ReducedIndividualPerson';
import ReducedLegalEntity from './ReducedLegalEntity';
import { CompanyNameType } from '../../static/types/commonTypes/companyNameType';

type ReducedManagerListPropsQualities = {
    checked: boolean,
    companyName: CompanyNameType
    societyTypeOptions: string[],
    managers: ReducedManagerTypeWithQuality[],
    qualitiesOptions: string[],
    addButtonText: string,
    removeButtonText: string,
    labelItem?: string,
    setManagers: React.Dispatch<React.SetStateAction<ReducedManagerTypeWithQuality[]>>
    setManagersValidity: (isValid: boolean) => void
}

export default function ReducedManagerListWithQualities({
    checked,
    societyTypeOptions,
    qualitiesOptions,
    managers,
    labelItem,
    setManagers,
    addButtonText,
    removeButtonText,
    setManagersValidity,
}: ReducedManagerListPropsQualities) {

    let listValidity: boolean[] = [false]

    const addManager = () => {
        setManagers([
            ...managers,
            initialReducedManagerTypeWithQualityState
        ]);
        listValidity.push(false)
    };

    const removeLastManager = () => {
        if (managers.length > 1) {
            setManagers(managers.slice(0, -1));
        }
        if (listValidity.length > 1) {
            listValidity.slice(0, -1)
        }
    };

    const updateManager = (index: number, updatedManager: ReducedManagerTypeWithQuality) => {
        const newManagers = [...managers];
        newManagers[index] = updatedManager;
        setManagers(newManagers);
    };

    const toggleManagerType = (person: "Personne physique" | "Personne morale", index: number) => {
        const newManager: ReducedManagerTypeWithQuality = person === "Personne physique"
            ? {
                person: "Personne physique",
                personDetails: initialReducedIndividualState,
                qualite: "Gérant"
            }
            : {
                person: "Personne morale",
                entityDetails: initialReducedLegalEntityState,
                qualite: "Gérant"
            };

        updateManager(index, newManager);
    };

    const updateManagersValidity = (index: number, isValid: boolean) => {
        listValidity[index] = isValid;
        setManagersValidity(listValidity.every(valid => valid));
    };

    const updateQuality = (index: number, qualite: string) => {
        const newManagers = [...managers];
        newManagers[index] = { ...newManagers[index], qualite };
        console.log({...newManagers[index], qualite})
        setManagers(newManagers);
    };


    return (
        <>
            <div className="mb-3 row">
                {
                    managers.map((manager, index) =>

                        <div key={index} className="tab-content mb-2">

                            <div className="mb-3 row pt-3">

                                <div className="mb-3 row">
                                    <div className="col-sm-10">
                                        {labelItem ? <h6 className='text-bold'>{`${labelItem} ${index + 1}`}</h6> : ""}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <label htmlFor="qualite" className="col-sm-2 col-form-label">Qualité</label>
                                    <div className="col-sm-10">
                                        <select
                                            className="form-select"
                                            id="qualite"
                                            onChange={event => updateQuality(index, event.target.value)}
                                            value={manager.qualite}
                                        >
                                            {
                                                qualitiesOptions.map((option) => (
                                                    <option key={option} value={option}>
                                                        {option}
                                                    </option>
                                                ))}
                                        </select>


                                    </div>
                                </div>


                                <div className="mb-3 row">

                                    <label htmlFor="personne" className="col-sm-2 col-form-label">Personne</label>

                                    <div className="col-sm-10">
                                        <select
                                            className="form-select"
                                            id="person"
                                            onChange={e => toggleManagerType(
                                                e.target.value as "Personne physique" | "Personne morale",
                                                index
                                            )}
                                            value={manager?.person || ""}
                                        >
                                            {
                                                entityTypes.map(option =>
                                                    <option key={option} value={option}>
                                                        {option}
                                                    </option>
                                                )
                                            }
                                        </select>
                                    </div>

                                </div>
                            </div>

                            {
                                manager.person === "Personne physique"
                                    ?
                                    <ReducedIndividualPerson
                                        reducedIndividualPerson={manager.personDetails}
                                        checked={checked}
                                        onValidationChange={(isValid: boolean) => updateManagersValidity(index, isValid)}
                                        changeReducedIndividualPerson={details => {
                                                const updatedManager: ReducedManagerTypeWithQuality = {
                                                    ...manager,
                                                    personDetails: { ...manager.personDetails, ...details }
                                                };
                                                updateManager(index, updatedManager);
                                            }}
                                    />
                                    :
                                    <ReducedLegalEntity
                                        checked= {checked}
                                        onValidationChange= {(isValid: boolean) => updateManagersValidity(index, isValid)}
                                        reducedLegalEntity= {manager.entityDetails}
                                        changeReducedLegalEntity= {details => {
                                                const updatedManager: ReducedManagerTypeWithQuality = {
                                                    ...manager,
                                                    entityDetails: { ...manager.entityDetails, ...details }
                                                };
                                                updateManager(index, updatedManager);
                                            }}
                                    />
                            }
                        </div>
                    )
                }
            </div>

            <div className="row mb-3">
                <div className="col d-flex justify-content-center align-items-center gap-5">
                    <button type='button' onClick={addManager}> {addButtonText} </button>
                    {managers.length > 1 && <button type='button' onClick={removeLastManager}> {removeButtonText} </button>}
                </div>
            </div>
        </>
    )
};